<template>
  <div>
    <!-- Search -->
    <TaskFilter />
    <DataTable
      :rowKeys="['taskId']"
      :rows="tasks"
      :actions="
        readOnly
          ? [
              {
                name: 'workflow',
                label: 'Workflow',
                params: { workflowId: 'workflowId' }
              },
              {
                name: 'task',
                label: 'View',
                params: { taskId: 'taskId' }
              }
            ]
          : [
              {
                name: 'workflow',
                label: 'Workflow',
                params: { workflowId: 'workflowId' }
              },
              {
                name: 'task',
                label: 'View',
                params: { taskId: 'taskId' }
              },
              {
                name: 'taskResultEdit',
                label: 'Update',
                params: { taskId: 'taskId' }
              },
              { name: 'dequeue', label: 'Dequeue', function: actionDequeueTask }
            ]
      "
      :columns="[
        { name: 'taskId', type: 'text' },
        { name: 'workflowId', type: 'text' },
        { name: 'workflowType', type: 'text' },
        { name: 'taskType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'executionTime', type: 'duration' },
        { name: 'scheduledTime', type: 'date' },
        { name: 'startTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'reasonForIncompletion', type: 'text' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import TaskFilter from '@/components/TaskFilter.vue'

export default {
  name: 'TaskList',
  computed: mapState(['tasks', 'readOnly']),
  methods: {
    ...mapActions(['getTasks', 'dequeueTask']),
    actionDequeueTask(task) {
      this.dequeueTask([task.taskType, task.taskId])
    }
  },
  created() {
    this.getTasks()
  },
  components: {
    DataTable,
    TaskFilter
  }
}
</script>
